/* eslint-disable import/prefer-default-export */
import { ScaleLimits } from 'shared/components/likert-scale/types';

const MIN_SCALE_VALUE = 1;
const MAX_SCALE_VALUE = 5;

export const scaleLimits: ScaleLimits = {
  min: {
    value: MIN_SCALE_VALUE,
  },
  max: {
    value: MAX_SCALE_VALUE,
  },
};
